
import ReactDOM from "react-dom";
import { Fragment } from "react";
import classes from "./Modal.module.css";

const Backdrop = props => {
    return <div onClick={props.onCloseCart} className={classes.backdrop} ></div>
}

const ModalOverlay = props => {
    return <div className={classes.modal} >
        <div className={classes.content}>{props.children}</div>
    </div>
}
const portalElement = document.getElementById("overlays")

const Model = props => {
    return <Fragment>
        {ReactDOM.createPortal(<Backdrop onCloseCart={props.onCloseCart} />, portalElement)}
        {ReactDOM.createPortal(<ModalOverlay>{props.children}</ModalOverlay>, portalElement)}
    </Fragment>

}
export default Model